import { Loading } from '@components/loadling';
import { initSdk, onApiError } from '@proccess/api';
import { CurrentEnv } from '@proccess/constants';
import { notistackRef } from '@proccess/ref/noti';
import { PayloadAction } from '@reduxjs/toolkit';
import { AppState } from '@store';
import { actions } from '@store/reducer';
import { AxiosResponse } from 'axios';
import { get } from 'lodash';
import { all, call, fork, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

function* requestBookings({
  payload: { page = 0, limit = 20 },
}: PayloadAction<{ page?: number; limit?: number }>) {
  try {
    Loading.Show();
    const { data }: AxiosResponse = yield call(() =>
      initSdk.get('/admin/bookings', {
        params: {
          page,
          limit,
        },
      })
    );

    if (data) {
      yield put(actions.saveBookings({ list: data, limit }));
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestBookings() {
  yield takeEvery(actions.requestBookings, requestBookings);
}

function* requestBookingDetail({ payload: { id } }: any) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() => initSdk.get(`/admin/bookings/${id}`));

    if (response.data) {
      yield put(actions.saveBookingDetail({ data: response.data.booking }));
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestBookingDetail() {
  yield takeLatest(actions.requestBookingDetail, requestBookingDetail);
}

function* requestCreateBooking() {
  try {
    Loading.Show();
    const {
      schedule,
      patient,
      payment: { select_payment },
    }: AppState = yield select((s) => s);

    const { doctor, service, subject, date, booking_reason, time } = schedule.scheduled;

    const postdata = {
      // redirect_url: `${window.location.origin}/${urlSegment.PhieuHen}`,
      payment_bank_code_id: select_payment?.id,
      payment_method_id: select_payment?.id,
      patient_id: patient.select_patient?.id,
      booking_date: date?.id,
      bookings: [
        {
          doctor_id: doctor?.id,
          service_id: service?.id,
          subject_id: subject?.id,
          service_patient_object_id: service?.other?.insurance_choice?.id,
          ptime_id: time?.id,
          booking_reason,
        },
      ],
    };

    const { data }: AxiosResponse = yield call(() =>
      initSdk.post('/admin/bookings?create', postdata)
    );

    if (data) {
      yield call(() =>
        notistackRef.current?.enqueueSnackbar('Tạo phiếu khám thành công', { variant: 'success' })
      );
      yield put(actions.saveCreacteBooking({ data }));
      yield put(actions.resetAnyKeySchedule({ key: 'scheduled', data: {} }));
      yield window.open(
        `${CurrentEnv?.BASE_WEB}/phieu-kham/share/${data?.bookings?.[0]?.booking_code}`,
        '_blank'
      );
    }
  } catch (error: any) {
    console.error('error', error);
    const message = get(error, 'response.data.message', 'Lỗi hệ thống!');
    notistackRef.current?.enqueueSnackbar(message, { variant: 'error' });
    Loading.Hide();
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestCreateBooking() {
  yield takeLatest(actions.requestCreateBooking, requestCreateBooking);
}

const bookingSagas = function* root() {
  yield all([
    fork(watcherRequestCreateBooking),
    fork(watcherRequestBookings),
    fork(watcherRequestBookingDetail),
  ]);
};
export { bookingSagas };
